<sh-button
    href="/"
    [label]="'general.back-to-dashboard' | translate"
    color="tertiary"
    layout="compact"
    icon="arrow-line-left-s"
    iconPosition="left"
/>
